/** Central API URL for fetch calls (production uses same-origin /api via cPanel proxy). */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:5001/api' : '/api');

/** Origin without /api suffix — for static assets like receipt images. */
export const API_ORIGIN =
  API_BASE_URL.replace(/\/api\/?$/, '') ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5001');
